// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Save Chart Modal Overlay */
.save-chart-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(3px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Modal Container */
.save-chart-modal {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  border: 2px solid #4a7c7e;
  border-radius: 15px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.8);
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Modal Header */
.save-chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(74, 124, 126, 0.3);
  background: linear-gradient(135deg, rgba(74, 124, 126, 0.1) 0%, transparent 100%);
}

.save-chart-header h2 {
  margin: 0;
  color: #fff;
  font-family: 'Orbitron', monospace;
  font-size: 20px;
  font-weight: 700;
  background: linear-gradient(135deg, #4a7c7e 0%, #7eb3b5 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Close Button */
.save-chart-close-btn {
  background: transparent;
  border: none;
  color: #7eb3b5;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.save-chart-close-btn:hover {
  background: rgba(126, 179, 181, 0.1);
  color: #fff;
  transform: rotate(90deg);
}

/* Modal Body */
.save-chart-body {
  padding: 24px;
  flex: 1 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Label */
.save-chart-label {
  color: #ccc;
  font-family: 'Orbitron', monospace;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
  display: block;
}

/* Input Field */
.save-chart-input {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #4a7c7e;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
  font-family: 'Orbitron', monospace;
  font-size: 14px;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.save-chart-input:focus {
  outline: none;
  border-color: #7eb3b5;
  background: rgba(74, 124, 126, 0.1);
  box-shadow: 0 0 10px rgba(126, 179, 181, 0.3);
}

.save-chart-input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Character Count */
.char-count {
  color: #666;
  font-family: 'Orbitron', monospace;
  font-size: 12px;
  text-align: right;
  margin-top: -8px;
}

/* Error Message */
.save-chart-error {
  background: rgba(244, 67, 54, 0.1);
  border: 1px solid rgba(244, 67, 54, 0.3);
  color: #ff9999;
  padding: 10px 12px;
  border-radius: 6px;
  font-family: 'Orbitron', monospace;
  font-size: 12px;
  margin-top: 8px;
}

/* Modal Footer */
.save-chart-footer {
  display: flex;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid rgba(74, 124, 126, 0.3);
  background: linear-gradient(135deg, transparent 0%, rgba(74, 124, 126, 0.05) 100%);
}

/* Buttons */
.save-chart-cancel-btn,
.save-chart-submit-btn {
  flex: 1 1;
  padding: 12px 16px;
  border: 2px solid #4a7c7e;
  border-radius: 8px;
  font-family: 'Orbitron', monospace;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Cancel Button */
.save-chart-cancel-btn {
  background: transparent;
  color: #7eb3b5;
}

.save-chart-cancel-btn:hover:not(:disabled) {
  background: rgba(74, 124, 126, 0.1);
  border-color: #7eb3b5;
}

/* Submit Button */
.save-chart-submit-btn {
  background: linear-gradient(135deg, #4a7c7e 0%, #7eb3b5 100%);
  color: #000;
  border: none;
}

.save-chart-submit-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(126, 179, 181, 0.4);
}

.save-chart-submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

/* Responsive Design */
@media (max-width: 640px) {
  .save-chart-modal {
    width: 95%;
    max-width: none;
  }

  .save-chart-header h2 {
    font-size: 18px;
  }

  .save-chart-body,
  .save-chart-footer {
    padding: 16px;
  }

  .save-chart-input {
    font-size: 16px; /* Prevent zoom on iOS */
  }
}

/* Print Styles */
@media print {
  .save-chart-modal-overlay {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/SaveChartModal.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,oBAAoB;AACpB;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gDAAgD;EAChD,iFAAiF;AACnF;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,UAAU;AACV;EACE,WAAW;EACX,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;EACX,kCAAkC;EAClC,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,6CAA6C;EAC7C,kFAAkF;AACpF;;AAEA,YAAY;AACZ;;EAEE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,6DAA6D;EAC7D,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,eAAe,EAAE,wBAAwB;EAC3C;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/* Save Chart Modal Overlay */\n.save-chart-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(3px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2000;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Modal Container */\n.save-chart-modal {\n  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);\n  border: 2px solid #4a7c7e;\n  border-radius: 15px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.8);\n  max-width: 500px;\n  width: 90%;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  animation: slideUp 0.3s ease-out;\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(20px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n/* Modal Header */\n.save-chart-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid rgba(74, 124, 126, 0.3);\n  background: linear-gradient(135deg, rgba(74, 124, 126, 0.1) 0%, transparent 100%);\n}\n\n.save-chart-header h2 {\n  margin: 0;\n  color: #fff;\n  font-family: 'Orbitron', monospace;\n  font-size: 20px;\n  font-weight: 700;\n  background: linear-gradient(135deg, #4a7c7e 0%, #7eb3b5 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Close Button */\n.save-chart-close-btn {\n  background: transparent;\n  border: none;\n  color: #7eb3b5;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.save-chart-close-btn:hover {\n  background: rgba(126, 179, 181, 0.1);\n  color: #fff;\n  transform: rotate(90deg);\n}\n\n/* Modal Body */\n.save-chart-body {\n  padding: 24px;\n  flex: 1;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* Label */\n.save-chart-label {\n  color: #ccc;\n  font-family: 'Orbitron', monospace;\n  font-size: 13px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 4px;\n  display: block;\n}\n\n/* Input Field */\n.save-chart-input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 2px solid #4a7c7e;\n  border-radius: 8px;\n  background: rgba(0, 0, 0, 0.3);\n  color: #fff;\n  font-family: 'Orbitron', monospace;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n}\n\n.save-chart-input:focus {\n  outline: none;\n  border-color: #7eb3b5;\n  background: rgba(74, 124, 126, 0.1);\n  box-shadow: 0 0 10px rgba(126, 179, 181, 0.3);\n}\n\n.save-chart-input:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Character Count */\n.char-count {\n  color: #666;\n  font-family: 'Orbitron', monospace;\n  font-size: 12px;\n  text-align: right;\n  margin-top: -8px;\n}\n\n/* Error Message */\n.save-chart-error {\n  background: rgba(244, 67, 54, 0.1);\n  border: 1px solid rgba(244, 67, 54, 0.3);\n  color: #ff9999;\n  padding: 10px 12px;\n  border-radius: 6px;\n  font-family: 'Orbitron', monospace;\n  font-size: 12px;\n  margin-top: 8px;\n}\n\n/* Modal Footer */\n.save-chart-footer {\n  display: flex;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid rgba(74, 124, 126, 0.3);\n  background: linear-gradient(135deg, transparent 0%, rgba(74, 124, 126, 0.05) 100%);\n}\n\n/* Buttons */\n.save-chart-cancel-btn,\n.save-chart-submit-btn {\n  flex: 1;\n  padding: 12px 16px;\n  border: 2px solid #4a7c7e;\n  border-radius: 8px;\n  font-family: 'Orbitron', monospace;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Cancel Button */\n.save-chart-cancel-btn {\n  background: transparent;\n  color: #7eb3b5;\n}\n\n.save-chart-cancel-btn:hover:not(:disabled) {\n  background: rgba(74, 124, 126, 0.1);\n  border-color: #7eb3b5;\n}\n\n/* Submit Button */\n.save-chart-submit-btn {\n  background: linear-gradient(135deg, #4a7c7e 0%, #7eb3b5 100%);\n  color: #000;\n  border: none;\n}\n\n.save-chart-submit-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(126, 179, 181, 0.4);\n}\n\n.save-chart-submit-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Responsive Design */\n@media (max-width: 640px) {\n  .save-chart-modal {\n    width: 95%;\n    max-width: none;\n  }\n\n  .save-chart-header h2 {\n    font-size: 18px;\n  }\n\n  .save-chart-body,\n  .save-chart-footer {\n    padding: 16px;\n  }\n\n  .save-chart-input {\n    font-size: 16px; /* Prevent zoom on iOS */\n  }\n}\n\n/* Print Styles */\n@media print {\n  .save-chart-modal-overlay {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
